import { Container, Rectangle } from 'pixi.js'
import { dimensions } from '../../config/settings'
import { createLayers, createBulletLayers } from './layerFactory'
import { startParallax } from './parallaxController'
import Item from '../Item'
import Layer from './index'
import LayerBase from './LayerBase'

export default class LayersContainer extends Container {
  private layers: Layer[] = []
  private bulletLayers: LayerBase[] = []
  private _items: Item[] = []
  private readonly isLowEnd: boolean

  get items(): Item[] {
    return this._items
  }

  constructor(isLowEnd: boolean) {
    super()
    this.isLowEnd = isLowEnd
    this.hitArea = new Rectangle(0, 0, dimensions.SCENE_WIDTH, dimensions.SCENE_HEIGHT)

    this.layers = createLayers(isLowEnd)
    this.layers.forEach((layer) => this.addChild(layer))

    const { bulletLayers, items } = createBulletLayers(this.layers)
    this.bulletLayers = bulletLayers
    this._items = items
    // bulletLayers.forEach((bulletLayer) => this.addChild(bulletLayer))

    this.centerScene()
  }

  private centerScene(): void {
    this.x = -(dimensions.SCENE_WIDTH - dimensions.MAX_WIDTH) / 2
    this.y = -(dimensions.SCENE_HEIGHT - dimensions.MAX_HEIGHT) / 2
  }

  public startParallax(): void {
    startParallax(this.layers, this.bulletLayers)
  }
}
